import FormattedMessage from 'I18n/components/FormattedMessage';
import { getButtonVariantProps } from 'pricing-pages-lib/utils/buttonVariantUtils';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import SignupButton from 'pricing-pages-ui/components/common/SignupButton';
import SkeletonLoadWrapper from 'pricing-pages-ui/components/common/loading/SkeletonLoadWrapper';
import { HighlightedProductsHeaderConfig } from 'pricing-pages-ui/constants/merchCards/HighlightedProductsHeaderConfig';
import { useSelector } from 'react-redux';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { FREE_CARD } from '../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { ownsCrmSuiteProductLevel } from '../../selectors/ProductInventorySelectors';
import CurrentPlanTag from '../common/badges/CurrentPlanTag';
import { MerchCardWrapper } from './MerchCardSharedComponents';
import SuiteBusinessObjectives from './business-objectives/SuiteBusinessObjectives';
import HighlightedFreePriceDisplay from './price-display/HighlightedFreePriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HighlightedFreeCard = ({
  productLine,
  gridItemProps
}) => {
  const isAppReady = useGlobalLoading();
  const isCurrentPlanLevel = useSelector(state => ownsCrmSuiteProductLevel(state, {
    productLevel: FREE
  }));
  const ctaVariantProps = getButtonVariantProps({
    variant: 'block'
  });

  // In order for the grid to work, the wrapper element requires display: contents.
  // Children of the display grid item must get the grid-start attributes directly
  return /*#__PURE__*/_jsxs(MerchCardWrapper, {
    children: [/*#__PURE__*/_jsxs(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "800",
      position: "relative",
      gridRowStart: 1,
      children: [isCurrentPlanLevel && /*#__PURE__*/_jsx(CurrentPlanTag, {}), /*#__PURE__*/_jsx(SectionTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "merchCards.freeCard.title"
        })
      })]
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "600",
      gridRowStart: 2,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: productLine === 'crm' ? 'merchCards.freeCard.description.crm' : HighlightedProductsHeaderConfig[productLine][FREE].subtitle
      })
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "400",
      gridRowStart: 3,
      children: /*#__PURE__*/_jsx(HighlightedFreePriceDisplay, {})
    })), /*#__PURE__*/_jsx(PPUIGridItem, Object.assign({}, gridItemProps, {
      paddingBlockStart: "400",
      gridRowStart: 6,
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !isAppReady,
        heights: [47],
        widths: ['100%'],
        children: /*#__PURE__*/_jsx(SignupButton, Object.assign({
          sourceId: "pricing-hero",
          productLine: productLine,
          use: "primary",
          nonMerchandiseIdProduct: "crm",
          trackingSource: FREE_CARD
        }, ctaVariantProps))
      })
    })), /*#__PURE__*/_jsx(PPUIGrid, Object.assign({}, gridItemProps, {
      gridTemplateRows: "subgrid",
      gridRowStart: 7,
      gridRowEnd: 9,
      children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !isAppReady,
        heights: [47],
        widths: ['100%'],
        children: /*#__PURE__*/_jsx(SuiteBusinessObjectives, {
          productLevel: FREE
        })
      })
    }))]
  });
};
export default HighlightedFreeCard;